import { User } from "./user";

/**
*   Comment model
*/

export class Comment {

    public moteKey: string = "";
    public text: string = "";
    public createdBy: string = "";
    public createdOn: any = "";
    public user: User = null;

    constructor(public key: string = null, json: any = null) {
        if(json) this.updateFromJson(json);
    }

    public updateFromJson(json: any): void {
        this.createdBy = json.createdBy || "";
        this.createdOn = json.createdOn || "";
        this.text = json.text || "";
        this.moteKey = json.moteKey || "";
    }

    public toJson() {
        let json = {
            text: this.text,
            moteKey: this.moteKey,
            createdBy: this.createdBy,
            createdOn: this.createdOn
        };
        return json;
    }
}
